import axios from "axios";
import api from "../api/index";
import categories from "../moked/categories.json";
import tags from "../moked/tags.json";
import templates from "../moked/templates.json";

import { storeMok } from "../moked/store";

const GET_ALL_STORES_REQUEST = "FARMAKOM/EDITOR/GET_ALL_STORES_REQUEST";
const GET_ALL_STORES_SUCCESS = "FARMAKOM/EDITOR/GET_ALL_STORES_SUCCESS";
const GET_ALL_STORES_FAILURE = "FARMAKOM/EDITOR/GET_ALL_STORES_FAILURE";

const GET_STORE_REQUEST = "FARMAKOM/EDITOR/GET_STORE_REQUEST";
const GET_STORE_SUCCESS = "FARMAKOM/EDITOR/GET_STORE_SUCCESS";
const GET_STORE_FAILURE = "FARMAKOM/EDITOR/GET_STORE_FAILURE";

const CREATE_STORE_REQUEST = "FARMAKOM/EDITOR/CREATE_STORE_REQUEST";
const CREATE_STORE_SUCCESS = "FARMAKOM/EDITOR/CREATE_STORE_SUCCESS";
const CREATE_STORE_FAILURE = "FARMAKOM/EDITOR/CREATE_STORE_FAILURE";

const UPDATE_STORE_REQUEST = "FARMAKOM/EDITOR/UPDATE_STORE_REQUEST";
const UPDATE_STORE_SUCCESS = "FARMAKOM/EDITOR/UPDATE_STORE_SUCCESS";
const UPDATE_STORE_FAILURE = "FARMAKOM/EDITOR/UPDATE_STORE_FAILURE";

const DELETE_STORE_REQUEST = "FARMAKOM/EDITOR/DELETE_STORE_REQUEST";
const DELETE_STORE_SUCCESS = "FARMAKOM/EDITOR/DELETE_STORE_SUCCESS";
const DELETE_STORE_FAILURE = "FARMAKOM/EDITOR/DELETE_STORE_FAILURE";

const DUPLICATE_STORE_REQUEST = "FARMAKOM/EDITOR/DUPLICATE_STORE_REQUEST";
const DUPLICATE_STORE_SUCCESS = "FARMAKOM/EDITOR/DUPLICATE_STORE_SUCCESS";
const DUPLICATE_STORE_FAILURE = "FARMAKOM/EDITOR/DUPLICATE_STORE_FAILURE";

const initialState = {
  loading: false,
  error: false,
  singleStore: {
    ...storeMok,
    categories,
    categoryTags: tags,
  },
  data: [],
};

export default function reducerStores(state = initialState, action) {
  switch (action.type) {
    case GET_ALL_STORES_REQUEST:
      return { ...state, loading: true, error: false };
    case GET_ALL_STORES_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload.map((store) => {
          return { ...store, storeId: store.id };
        }),
      };
    case GET_ALL_STORES_FAILURE:
      return { ...state, loading: false, data: [], error: action.payload };
    case GET_STORE_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        // singleStore: null
      };
    case GET_STORE_SUCCESS:
      return {
        ...state,
        loading: false,
        singleStore: {
          ...state.singleStore,
          ...action.payload,
        },
      };
    case GET_STORE_FAILURE:
      return {
        ...state,
        loading: false,
        // singleStore: {
        //   ...storeMok,
        // },
        error: action.payload,
      };
    case DUPLICATE_STORE_REQUEST:
      return { ...state, loading: true, error: false };
    case DUPLICATE_STORE_SUCCESS:
      return {
        ...state,
        loading: false,
        singleStore: {
          ...action.payload,
          storeId: action.payload.id,
          primaryColor: action.payload.brandColor,
        },
        data: [
          ...state.data,
          {
            ...action.payload,
            storeId: action.payload.id,
            primaryColor: action.payload.brandColor,
          },
        ],
      };
    case DUPLICATE_STORE_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case CREATE_STORE_REQUEST:
      return { ...state, loading: true, error: false };
    case CREATE_STORE_SUCCESS:
      return {
        ...state,
        loading: false,
        singleStore: {
          ...action.payload,
          storeId: action.payload.id,
          primaryColor: action.payload.brandColor,
        },
        data: [
          ...state.data,
          {
            ...action.payload,
            storeId: action.payload.id,
            primaryColor: action.payload.brandColor,
          },
        ],
      };
    case CREATE_STORE_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case UPDATE_STORE_REQUEST:
      return { ...state, loading: true, error: false };
    case UPDATE_STORE_SUCCESS:
      return {
        ...state,
        loading: false,
        singleStore: {
          ...state.singleStore,
          ...action.payload,
          storeId: action.payload.id,
          primaryColor: action.payload.brandColor,
        },
        data: state.data.map((store) => {
          if (store.storeId === action.payload.id) {
            return {
              ...action.payload,
              storeId: action.payload.id,
              primaryColor: action.payload.brandColor,
            };
          }
          return store;
        }),
      };
    case UPDATE_STORE_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case DELETE_STORE_REQUEST:
      return { ...state, loading: true, error: false };
    case DELETE_STORE_SUCCESS:
      return {
        ...state,
        loading: false,
        data: state.data.filter((store) => store.id !== action.payload),
      };
    case DELETE_STORE_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
}

export const getAllStore = () => {
  return async (dispatch) => {
    dispatch({
      type: GET_ALL_STORES_REQUEST,
    });

    try {
      const { url, method, headers } = api.getAllStore();

      const stores = await axios({
        url,
        method,
        headers,
      });

      dispatch({
        type: GET_ALL_STORES_SUCCESS,
        payload: stores.data,
      });
    } catch (error) {
      // console.log("error", error);

      dispatch({
        type: GET_ALL_STORES_FAILURE,
        payload: error,
      });
    }
  };
};

export const getStoreById = (storeId) => {
  return async (dispatch) => {
    dispatch({
      type: GET_STORE_REQUEST,
    });
    try {
      const { url, method, headers } = api.getStoreById(storeId);

      const store = await axios({
        url,
        method,
        headers,
      });

      if (store) {
        // console.log("qui");
        dispatch({
          type: GET_STORE_SUCCESS,
          payload: store.data,
        });
      } else {
        // console.log("quo");
        dispatch({
          type: GET_STORE_FAILURE,
          payload: "Couldn't find store",
        });
      }
    } catch (error) {
      // console.log("qua");
      dispatch({
        type: GET_STORE_FAILURE,
        payload: error,
      });
    }
  };
};

export const duplicate = (storeId) => {
  return async (dispatch) => {
    dispatch({
      type: DUPLICATE_STORE_REQUEST,
    });
    try {
      const { url, method, headers } = api.duplicate(storeId);

      const store = await axios({
        url,
        method,
        headers,
      });

      if (store) {
        dispatch({
          type: DUPLICATE_STORE_SUCCESS,
          payload: store.data,
        });
      } else {
        dispatch({
          type: DUPLICATE_STORE_FAILURE,
          payload: "Couldn't duplicate store",
        });
      }
    } catch (error) {
      // console.log("qua");
      dispatch({
        type: DUPLICATE_STORE_FAILURE,
        payload: error,
      });
    }
  };
};

export const createStore = (storeData) => {
  return async (dispatch) => {
    dispatch({
      type: CREATE_STORE_REQUEST,
    });
    try {
      let obj = {};
      if (storeData.templateId) {
        const template = templates.find(
          (temp) => temp.storeId == storeData.templateId
        );

        obj = {
          brandColor: template.brandColor,
          secondaryColor: template.secondaryColor,
          // background: Number(template.background),
          // font: template.font,
          menu: Number(template.menu),
          slider: Number(template.slider),
          sliderTagsSide: template.sliderTagsSide,
          bannerHeader: Number(template.bannerHeader),
          bannerPromo: Number(template.bannerPromo),
          thumbnail: Number(template.thumbnail),
          services: Number(template.services),
          countdown: Number(template.countdown),
          blogNewsletter: Number(template.blogNewsletter),
          bannerCarousel: Number(template.bannerCarousel),
          position1: template.position1,
          position2: template.position2,
          position3: template.position3,
          position4: template.position4,
          position5: template.position5,
          position6: template.position6,
          position7: template.position7,
          position8: template.position8,
          position9: template.position9,
          ...storeData.data,
        };
      } else {
        obj = storeData;
      }

      const { url, method, headers, data } = api.create(obj);

      // console.log("data", data);
      const newStore = await axios({
        url,
        method,
        headers,
        data,
      });

      // console.log(newStore);

      dispatch({
        type: CREATE_STORE_SUCCESS,
        payload: newStore.data,
      });
    } catch (error) {
      // console.log(error);
      dispatch({
        type: CREATE_STORE_FAILURE,
        payload: error,
      });
    }
  };
};

export const updateStore = (storeId, storeUpdates) => {
  return async (dispatch) => {
    dispatch({
      type: UPDATE_STORE_REQUEST,
    });
    try {
      const obj = Object.entries(storeUpdates)
        .filter((attr) => !!attr[1])
        .reduce(function (acc, cur, i) {
          acc[cur[0]] = cur[1];
          return acc;
        }, {});

      const { url, method, headers, data } = api.updateStore(storeId, obj);

      const updatedStore = await axios({
        url,
        method,
        headers,
        data,
      });

      dispatch({
        type: UPDATE_STORE_SUCCESS,
        payload: updatedStore.data,
      });
    } catch (error) {
      // console.log(error);
      dispatch({
        type: UPDATE_STORE_FAILURE,
        payload: error,
      });
    }
  };
};

export const deleteStore = (storeId) => {
  return async (dispatch) => {
    dispatch({
      type: DELETE_STORE_REQUEST,
    });
    try {
      const { url, method, headers } = api.deleteStore(storeId);

      const deletedStore = await axios({
        url,
        method,
        headers,
      });

      if (deletedStore) {
        dispatch({
          type: DELETE_STORE_SUCCESS,
          payload: storeId,
        });
      } else {
        dispatch({
          type: DELETE_STORE_FAILURE,
          payload: "Couldn't delete store",
        });
      }
    } catch (error) {
      // console.log(error);
      dispatch({
        type: DELETE_STORE_FAILURE,
        payload: error,
      });
    }
  };
};
